// extracted by mini-css-extract-plugin
export default {"container":"SideContainerElement_container__0fwOm","title":"SideContainerElement_title__yZQ86"};